const resources = {
    // Paiement
    'CHECKOUT.NEW_ADDRESS.MESSAGE':
        'Ici, vous pouvez ajouter une nouvelle adresse à inclure sur cet accusé de réception de commande',
    'CHECKOUT.FOOTNOTE_MESSAGE':
        'Veuillez noter : Pour cette commande, vous serez facturé en {currencyDisplayCode}. En passant une commande, vous acceptez nos <a href="javascript:void(0)" data-toggle="modal" data-target="#checkout-terms-modal">conditions générales</a>.',
    'CHECKOUT.SUBMIT_BUTTON_CHARGE_ACCOUNT': 'Soumettre la commande',
    'CHECKOUT.SUBMIT_BUTTON_DEFAULT': 'Processus de paiement',

    // Sélectionnez le fournisseur de livraison modal
    'SELECT_DELIVERY_SUPPLIER_MODAL.DELIVERY_ADDRESS_HEADING':
        'Sélectionnez votre adresse de livraison',
    'SELECT_DELIVERY_SUPPLIER_MODAL.DELIVERY_ADDRESS_DESCRIPTION':
        'Sélectionnez parmi vos adresses de livraison précédemment utilisées.',
    'SELECT_DELIVERY_SUPPLIER_MODAL.RESELLER_HEADING': 'Sélectionnez votre revendeur',
    'SELECT_DELIVERY_SUPPLIER_MODAL.RESELLER_DESCRIPTION':
        'Sélectionnez parmi une liste de vos revendeurs disponibles à partir de votre adresse de livraison définie ci-dessus.',
    'SELECT_DELIVERY_SUPPLIER_MODAL.WHOLESALER_HEADING':
        'Sélectionnez votre grossiste',
    'SELECT_DELIVERY_SUPPLIER_MODAL.WHOLESALER_DESCRIPTION':
        'Sélectionnez parmi une liste de vos grossistes disponibles à partir de votre adresse de livraison définie ci-dessus.',
    'SELECT_DELIVERY_SUPPLIER_MODAL.ADD_NEW_DELIVERY_ADDRESS':
        'Ajouter une nouvelle adresse de livraison',
    'SELECT_DELIVERY_SUPPLIER_MODAL.ADD_NEW_RESELLER': 'Ajouter un nouveau revendeur',
    'SELECT_DELIVERY_SUPPLIER_MODAL.ADD_NEW_WHOLESALER': 'Ajouter un nouveau grossiste',

    'SELECT_DELIVERY_SUPPLIER_MODAL.LOCKED_RESELLER_INFO':
        'Votre revendeur est verrouillé car vous avez sélectionné son adresse de livraison ci-dessus.',
    'SELECT_DELIVERY_SUPPLIER_MODAL.LOCKED_WHOLESALER_INFO':
        'Votre grossiste est verrouillé car vous avez sélectionné son adresse de livraison ci-dessus.',

    'SELECT_DELIVERY_SUPPLIER_MODAL.CHANGE_RESELLER_CONFIRMATION_HEADING':
        'Changement de revendeur',
    'SELECT_DELIVERY_SUPPLIER_MODAL.CHANGE_RESELLER_CONFIRMATION_CONTENT':
        'Veuillez noter que le fait de changer de revendeur peut avoir une incidence sur votre panier existant, sur les prix et sur la disponibilité des stocks. Êtes-vous sûr de vouloir continuer ?',
    'SELECT_DELIVERY_SUPPLIER_MODAL.CHANGE_WHOLESALER_CONFIRMATION_HEADING':
        'Changer de grossiste',
    'SELECT_DELIVERY_SUPPLIER_MODAL.CHANGE_WHOLESALER_CONFIRMATION_CONTENT':
        'Veuillez noter que le fait de changer de grossiste peut avoir une incidence sur votre panier existant, sur les prix et sur la disponibilité des stocks. Êtes-vous sûr de vouloir continuer ?',

    'REJECT_CUSTOMERS_MODAL.REJECT_CUSTOMERS_HEADING': 'Rejet d’un compte',
    'REJECT_CUSTOMERS_MODAL.REJECT_CUSTOMERS_CONTENT':
        'Êtes-vous sûr de vouloir rejeter ce compte revendeur ? Ce revendeur recevra une notification et ne sera pas en mesure de commander auprès de vous, ou de recevoir des commandes de leurs clients.',
    'REJECT_CUSTOMERS_MODAL.REJECT_CUSTOMERS_CONFIRM': 'Rejeter',

    'REJECT_CUSTOM_ORDER_MODAL.REJECT_ORDER_HEADING': 'Rejet d’une commande',
    'REJECT_CUSTOM_ORDER_MODAL.REJECT_ORDER_CONTENT':
        'Êtes-vous sûr de vouloir rejeter cette commande ? Votre client recevra une notification et la commande sera annulée.',
    'REJECT_CUSTOM_ORDER_MODAL.REJECT_ORDER_CONFIRM': 'Rejeter',

    'PROCEED_WITHOUT_VALIDATION_MODAL.HEADING':
        "Procéder sans validation PIC (code d'identification des biens) ?",
    'PROCEED_WITHOUT_VALIDATION_MODAL.CONTENT':
        "J'atteste que les informations PIC fournies sont véridiques et correctes, ainsi que toutes les données associées, afin de satisfaire aux exigences de chaque État et territoire australien. En sélectionnant J'ACCEPTE, vous autorisez le recoupement de ces données avec les bases de données de l'État, du territoire et nationales à des fins de conformité. Un représentant de Leader Products vous contactera si nous ne sommes pas en mesure de vérifier les données.",
    'PROCEED_WITHOUT_VALIDATION_MODAL.CONFIRM': "J'ACCEPTE",

    // Liste des produits
    NO_PRODUCTS: 'Aucun produit',

    // Filtre produit
    'PRODUCT_LIST.FILTER': 'Filtre :',
    SORT_BY: 'Trier par :',
    LIST_STYLE: 'Style de liste :',

    // Filtre produit - Tri
    'SORT.RELEVANCE': 'Pertinence',
    'SORT.DEFAULT': 'Par défaut',
    'SORT.PRODUCT_NAME_ASC': 'Nom du produit (A-Z)',
    'SORT.PRODUCT_NAME_DESC': 'Nom du produit (Z-A)',
    'SORT.PRODUCT_CODE_ASC': 'Code produit (A-Z)',
    'SORT.PRODUCT_CODE_DESC': 'Code produit (Z-A)',
    'SORT.PRICE_ASC': 'Prix par ordre croissant',
    'SORT.PRICE_DESC': 'Prix par ordre décroissant',

    // Affichage du produit
    'PRODUCT.DESCRIPTION_HEADING': 'Description',
    'PRODUCT.SPECIFICATION_HEADING': 'Spécification',
    'PRODUCT.WIDTH': 'Largeur',
    'PRODUCT.HEIGHT': 'Hauteur',
    'PRODUCT.DEPTH': 'Profondeur',
    'PRODUCT.WEIGHT': 'Poids',
    SIGN_IN_TO_ORDER: "S'identifier pour commander",
    ADD_TO_CART: 'Ajouter au panier',
    UPDATE_TO_CART: 'Mise à jour du panier',
    RETURN_TO_CART: 'Retour au panier',
    MIN_ORDER_QUANTITY_MOBILE: '* Qté min. de commande :',
    MIN_ORDER_QUANTITY_DESKTOP: '* Quantité minimale de commande :',

    // Liste des produits en magasin
    REMOVE_CATEGORY: 'Supprimer la catégorie',
    CREATE_NEW_CATEGORY: 'Créer une nouvelle catégorie',
    ADD_OR_REMOVE_CATEGORY: 'Ajouter / Supprimer la catégorie',
    NEW_PRODUCT: 'Nouveau produit',
    'PRODUCT_NAME:PORTABLE': 'Nom',

    // Formulaire de produit en magasin
    PRODUCT_DETAILS: 'Détails du produit',
    PRODUCT_NAME: 'Nom du produit',
    PRODUCT_CODE: 'Code produit',
    YOUR_PRODUCTS: 'Vos produits',
    'IN_STORE_PRODUCT_FORM:DELETE_MODAL:HEADING': 'Procéder à l’enlèvement ?',
    'IN_STORE_PRODUCT_FORM:DELETE_MODAL:SUBHEADING':
        'Êtes-vous sûr que vous voulez supprimer ce produit ?',
    'IN_STORE_PRODUCT:REMOVE_PRODUCTS_SUCCESS_MESSAGE':
        '{total} produit(s) ont été retirés',
    'IN_STORE_PRODUCT:NEW_CATEGORY_SUCCESS_MESSAGE':
        '{category_name} a été créé',
    'IN_STORE_PRODUCT:REMOVE_CATEGORY_SUCCESS_MESSAGE':
        '{category_name} a été supprimé',

    // Détail client
    ORDER_HISTORY: 'Historique de la commande',
    ORDER_SUMMARY: 'Résumé de la commande',

    // Coupon
    COUPON: 'Coupon',
    YOUR_COUPONS: 'Vos coupons',
    CREATE_COUPON: 'Créer un coupon',
    COUPON_DETAILS: 'Détails du coupon',
    GENERATE_COUPON_CODE: 'Générer le code coupon',
    COUPON_CODE: 'Code coupon',
    COUPON_NAME: 'Nom du coupon',
    DISCOUNT_PERCENTAGE_ONLY: 'Remise (% seulement)',
    DISCOUNT: 'Remise',
    USAGE: 'Utilisation',
    SUB_LEVELS: 'Sous-Niveaux',
    EXPIRY: 'Expiration',
    EXPIRY_DATE: 'Date d’expiration',
    EXTENDED: 'Étendu',
    NON_EXTENDED: 'Non-Étendu',
    'USAGE.SINGLE': 'Seul',
    'USAGE.MULTIPLE': 'Plusieurs',
    'COUPON_TPYE.ORDER': 'Remise sur la commande',
    'COUPON_TPYE.PRODUCT': 'Remise sur le produit',

    // Coupon de référence
    REFERRAL_YOUR_COUPONS: 'Vos coupons de référence',
    REFERRAL_COUPON_Details: 'Détails du coupon de référence',
    REFERRAL_COUPON_CODE: 'CODE',
    REFERRAL_COUPON_ASSIGNED_TO: 'AFFECTÉ À',
    REFERRAL_COUPON_WHOLESALER: 'GROSSISTE',
    REFERRAL_COUPON_DISCOUNT: 'REMISE',
    REFERRAL_COUPON_PAYOUT: 'PAIEMENT',
    REFERRAL_COUPON_EXPIRY: 'EXPIRATION',
    REFERRAL_COUPON_SINGLE_USAGE: 'Seul',
    REFERRAL_COUPON_MULTIPLE_USAGE: 'Plusieurs',

    // Panier
    'CART.ADD_TO_CART.SUCCESS_MESSAGE': 'Le(s) article(s) a (ont) été ajouté(s) au panier',
    'CART.UPDATE_CART_ITEM.SUCCESS_MESSAGE': 'Votre article a été mis à jour',
    CUSTOM_TAG: 'Étiquette personnalisée',
    REMOVE_ITEM_FROM_CART: 'Retirer l’article du panier ?',
    CART_NO_ITEMS: 'Vous n’avez pas d’articles dans votre panier.',
    ORDER_NO_ITEMS: 'La commande n\'a pas d\'articles.',
    ORDER_QUANTITY_REQUIRED: 'Qté requise',
    ORDER_QUANTITY_PICKED: 'Qté cueillie',
    ORDER_QUANTITY_BO: 'Qté B.O',
    CONVERSION_RATE: 'Taux de conversion',
    WHOLESALE_BUY_PRICE: 'Prix d’achat en gros',
    WHOLESALE_BUY_PRICE_USD: 'Prix d’achat en gros en USD',
    WHOLESALE_BUY_PRICE_AUD: 'Prix d’achat en gros en AUD',
    WHOLESALE_ADJUSTABLE_RRP: 'Prix de gros ajustable RRP (prix de vente conseillé)',
    WHOLESALE_ADJUSTABLE_RESELLER_PRICE: 'Prix de gros ajustable pour revendeurs',
    WHOLESALE_ADJUSTABLE: 'Prix de gros ajustable',
    WHOLESALE_ADJUSTABLE_USD: 'Prix de gros ajustable en USD',
    WHOLESALE_ADJUSTABLE_AUD: 'Prix de gros ajustable en AUD',
    WHOLESALE_PRICE: 'Prix de gros',
    WHOLESALE_PRICE_USD: 'Prix de gros en USD',
    RESELLER_BUY_PRICE: 'Prix d’achat revendeur',
    RESELLER_ADJUSTABLE_RRP: 'RRP revendeur ajustable',
    RESELLER_ADJUSTABLE: 'Revendeur ajustable',
    RESELLER_ADJUSTABLE_AUD: 'Revendeur ajustable en AUD',
    QUECLINK_COGS: 'COGS (coût des marchandises vendues-CMV) Queclink',
    QUECLINK_COGS_USD: 'Queclink COGS en USD',
    QUECLINK_WHOLESALE_PRICE: 'Prix de gros Queclink en USD',
    QUECLINK_RESELLER_PRICE: 'Revendeur Queclink',
    QUECLINK_RESELLER_PRICE_USD: 'Revendeur Queclink USD',
    QUECLINK_RRP: 'RRP Queclink',
    LEADER_PRODUCTS_RRP: 'RRP Leader Produits',
    RRP: 'RRP',
    RRP_INC_TAX: 'RRP TTC',
    RRP_USD: 'RRP en USD',
    RRP_ADJUSTABLE: 'RRP ajustable',
    RRP_ADJUSTABLE_AUD: 'RRP ajustable en AUD',
    BUY_PRICE: 'Prix d’achat',
    PROFIT: 'GM%',
    COGS: 'COGS',
    COGS_USD: 'COGS en USD',
    RESELLER_PRICE: 'Prix revendeur',
    RESELLER_PRICE_EX_TAX: 'Prix revendeur H.T.',
    RESELLER_PRICE_USD: 'Prix revendeur en USD',
    RETAIL_PRICE: 'Prix de détail',
    SELL_PRICE_MIN: 'Prix de vente (min)',
    SELL_PRICE_MAX: 'Prix de vente (max)',
    CART: 'Panier',
    QTY: 'Qté',
    QUANTITY: 'Quantité',
    TAX: 'Taxe',
    TOTAL: 'Total',
    SUBTOTAL: 'SOUS-TOTAL',
    SOH: 'SOH (Stock disponible)',
    WAREHOUSE_SOH: 'Stock disponible en entrepôt',
    WAREHOUSE_SOH_MIN: 'Stock disponible en entrepôt (min)',
    WAREHOUSE_SOH_MAX: 'Stock disponible en entrepôt (max)',
    CHECKOUT: 'Paiement',
    CONTINUE_SHOPPING: 'Continuer à acheter',
    CUSTOM_TAG_TO_EDIT: 'Étiquette personnalisé - cliquez pour modifier',

    // Factures
    PAYMENT_STATUS: 'Statut du paiement',
    PAYMENT_DETAILS: 'Détails du paiement',
    'INVOICE.INVOICE_NO': 'N° de facture',
    'INVOICE.ORDER_NO': 'N° de commande',
    'INVOICE.RESELLER_BUSINESS_NAME': 'Revendeur',
    'INVOICE.WHOLESALER_BUSINESS_NAME': 'Grossiste',
    'INVOICE.PLACED_ON': 'Passée le',
    'INVOICE.PAID_ON': 'Payée le',
    'INVOICE.PAID_AMOUNT': 'Total',
    'INVOICE.TOTAL_DUE': 'Total',
    'INVOICE.DUE_DATE': 'Date d’échéance',
    'INVOICE.STATUS': 'Statut',
    'INVOICE.SELECT': 'Sélectionnez',

    // Factures réciproques
    'RECIPROCAL_RECEIPTS.HEADING': 'Vos factures réciproques',
    'RECIPROCAL_RECEIPTS.HEADING_CA': 'Vos relevés de paiement de la TPS et de la TVH',

    // Récépissés
    'RECEIPTS.HEADING': 'Vos récépissés',

    // Manifeste
    MANIFEST: 'Manifeste',
    MANIFEST_LIST: 'Liste des manifestes',
    MANIFEST_ID: 'Identification du manifeste',
    MANIFEST_STATUS: 'Statut du manifeste',
    PROCESSED: 'Traité',
    PRINTED: 'Imprimé',
    UNPRINTED: 'Non imprimé',

    // Commande
    ORDER_NUMBER: 'Numéro de commande',
    ORDER_NO: 'N° de commande',
    ORDER_STATUS: 'Statut de la commande',
    TRACKING_NUMBER: 'Numéro de suivi',
    PAYMENT_TYPE: 'Type de paiement',
    PAYMENT_METHOD: 'Méthode de paiement',
    TAGS: 'Étiquettes',
    TAGS_YES: 'Oui',
    TAGS_NO: 'Non',
    RESELLER: 'Revendeur',
    SUPPLIER: 'Fournisseur',
    DATE_ORDERED: 'Commandé le',
    ORDERED: 'Commandé',
    DATE_PAID: 'Payée le',
    PAID: 'Payée',
    YOUR_RECEIPTS: 'Vos récépissés',
    ID: 'Identifiant',
    Approval: 'Approuver',
    REJECT: 'Rejeter',
    ORDER_APPROVAL: 'Approbation de la commande',
    SHIPPING_STATUS: 'Statut d’expédition',
    WHOLESALER: 'GROSSISTE',

    // Compte lié
    PIC_NUMBERS: 'Numéros PIC',
    BUSINESS_NAME: 'Nom d’entreprise',
    NAME: 'Nom',
    FIRST_NAME: 'Prénom',
    LAST_NAME: 'Nom de famille',
    TOWN: 'Ville',

    CURRENT_DELIVERY: 'Livraison actuelle',
    CURRENT_BILLING: 'Facturation actuelle',

    // Numéro PIC
    ADD_NEW_PIC_NUMBER: 'Ajouter un nouveau numéro PIC',

    COPY_REGISTRATION_URL: "Copier l'URL d'inscription",
    REGISTRATION_URL_COPIED: '"Copié dans le presse-papiers"    ',

    // Champs
    'FIELD.ID': 'Identifiant',
    'FIELD.PRODUCT': 'Produit',
    'FIELD.DATE_FROM': 'Date (du)',
    'FIELD.DATE_UNTIL': 'Date (jusqu’au)',
    'FIELD.ORDER_STATUS': 'Statut de la commande',
    'FIELD.PAYMENT_TYPE': 'Type de paiement',
    'FIELD.SUPPLIER': 'Fournisseur',
    'FIELD.WHOLESALER': 'Grossiste',
    'FIELD.RESELLER': 'Revendeur',
    'FIELD.TOTAL_MIN': 'Total (Min)',
    'FIELD.TOTAL_MAX': 'Total (Max)',
    'FIELD.PRODUCT_CODE': 'Code produit',
    'FIELD.PRODUCT_NAME': 'Nom du produit',
    'FIELD.WAREHOUSE_SOH_MIN': 'Stock disponible en entrepôt (min)',
    'FIELD.WAREHOUSE_SOH_MAX': 'Stock disponible en entrepôt (max)',
    'FIELD.SELL_PRICE_MIN': 'Prix de vente (min)',
    'FIELD.SELL_PRICE_MAX': 'Prix de vente (max)',
    'FIELD.PIC_NUMBER': 'Numéro PIC',
    'FIELD.BUSINESS_NAME': 'Nom d’entreprise',
    'FIELD.TRADING_NAME': 'Nom commercial',
    'FIELD.FIRST_NAME': 'Prénom',
    'FIELD.LAST_NAME': 'Nom de famille',
    'FIELD.TOWN': 'Ville',
    'FIELD.PHONE': 'Téléphone',
    'FIELD.FAX': 'FAX',
    'FIELD.MOBILE': 'Numéro de portable',
    'FIELD.EMAIL': 'Courriel',
    'FIELD.EMAIL_CONFIRMATION': 'Confirmer le courriel',
    'FIELD.WEBSITE': 'Site internet',
    'FIELD.ACCESS_CODE_TO_COPY_URL': "Code d'accès pour copier Reg. URL",
    'FIELD.PASSWORD': 'Mot de passe',
    'FIELD.PASSWORD_CONFIRMATION': 'Confirmer le mot de passe',
    'FIELD.NEW_PASSWORD': 'Nouveau mot de passe',
    'FIELD.NEW_PASSWORD_CONFIRMATION': 'Confirmer le nouveau mot de passe',
    'FIELD.STRIPE_PUBLISHABLE_KEY': 'Clé publiable Stripe',
    'FIELD.STRIPE_SECRET_KEY': 'Clé secrète Stripe',
    'FIELD.CREATED_FROM': "Date d'adhésion (du)",
    'FIELD.CREATED_UNTIL': "Date d'adhésion (jusqu’au)",
    'FIELD.SELECT_CARD': 'Sélectionnez une carte',
    'FIELD.SAVE_CARD': 'Enregistrer cette carte',
    'FIELD.OPERATOR_CODE': 'Code de l’opérateur',
    'FIELD.CREDIT_CARD': 'Carte de crédit',
    'FIELD.CHARGE_ACCOUNT': 'Compte de frais',
    'FIELD.BANK_TRANSFER': 'Virement bancaire',

    'FIELD.FIND_ADDRESS': 'Trouver l’adresse',

    'FIELD.POSTMEN_CARRIER_NAME': 'TRANSPORTEUR',
    'FIELD.POSTMEN_CARRIER_STATUS': 'STATUT',
    'FIELD.POSTMEN_CARRIER_STATUS_ACTIVE': 'Actif',
    'FIELD.POSTMEN_CARRIER_STATUS_INACTIVE': 'Inactif',
    'FIELD.POSTMEN_CARRIER_EDIT': 'Modifier le transporteur',
    'FIELD.POSTMEN_CARRIER_DELETE': 'Suppression du transporteur',

    'FIELD.CARTRULE_TITLE': 'Titre',
    'FIELD.CARTRULE_DISCOUNT': 'Remise',
    'FIELD.CARTRULE_MIN_AMOUNT': 'Passer',
    'FIELD.CARTRULE_ENABLED': 'Activé',

    'FIELD.COUPON_CODE': 'Code coupon',
    'FIELD.COUPON_NAME': 'Nom du coupon',
    'FIELD.CUSTOMER_DISCOUNT': 'Remise client',
    'FIELD.PAYOUT_PERCENTAGE': 'Pourcentage de versement',
    'FIELD.PERCENTAGE_ONLY': 'Pourcentage seulement (c.-à-d. 5 %)',
    'FIELD.DISCOUNT_PERCENTAGE_ONLY': 'Remise (% seulement)',
    'FIELD.DISCOUNT': 'Remise',
    'FIELD.USAGE': 'Utilisation',
    'FIELD.TYPE': 'Type',
    'FIELD.EXPIRY': 'Expiration',
    'FIELD.EXPIRY_DATE': 'Date d’expiration',
    'FIELD.EXTENDED_SUB_LEVELS': 'Étendre aux Sous-niveaux',
    'FIELD.ADD_NOTE': 'Ajouter la note',

    'FIELD.NZBN': 'NZBN',
    'FIELD.ABN': 'ABN',
    'FIELD.ACN': 'ACN',

    'FIELD.ORDER_NUMBER': 'Numéro de commande',
    'FIELD.INVOICE_NUMBER': 'Numéro de facture',
    'FIELD.SHIPPING_STATUS': 'Statut d’expédition',

    'FIELD.PLACEHOLDER.SELECT_LAZY_LETTER': '-- Sélectionnez Lazy Letter --',
    'FIELD.PLACEHOLDER.SELECT_ADDRESS': '-- Sélectionnez l’adresse --',
    'FIELD.PLACEHOLDER.SELECT_RESELLER': '-- Sélectionnez le revendeur --',
    'FIELD.PLACEHOLDER.SELECT_WHOLESALER': '-- Sélectionnez le grossiste --',
    'FIELD.PLACEHOLDER.SELECT_ORDER_STATUS': '-- Sélectionnez le statut de la commande --',
    'FIELD.PLACEHOLDER.SELECT_SHIPPING_STATUS': '-- Sélectionnez le statut de l’expédition --',

    'FIELD.GROUP.PRODUCTS': 'Produits',
    'FIELD.GROUP.USER_ADDRESSES': 'Vos adresses',
    'FIELD.GROUP.RESELLER_ADDRESSES': 'Vos adresses de revendeurs',
    'FIELD.GROUP.WHOLESALER_ADDRESSES': 'Vos adresses de grossistes',
    'FIELD.GROUP.BUSINESS_ADDRESSES': 'Vos adresses d’affaires',

    'FIELD.GROUP.RECENTLY_USED_RESELLER': 'Revendeurs attribués',
    'FIELD.GROUP.RECENTLY_USED_WHOLESALER': 'Grossistes attribués',
    'FIELD.GROUP.OTHER_RESELLER': 'Autre revendeur',
    'FIELD.GROUP.OTHER_WHOLESALER': 'Autre grossiste',

    'FILE_UPLOAD.DROP_FILE_HERE': 'Déposer le fichier ici',
    'FILE_UPLOAD.DRAG_IMAGE_TO_UPLOAD': 'Faire glisser l’image à télécharger',
    'FILE_UPLOAD.DRAG_DOCUMENT_TO_UPLOAD': 'Faire glisser le document à télécharger',
    'FILE_UPLOAD.BROWSE_YOUR_COMPUTER':
        'ou, <span class="field__dropzone-explanation__highlight">parcourez</span> votre ordinateur',
    'FILE_UPLOAD.REPLACE_THIS_IMAGE': '<span>Remplacez</span> cette image.',
    'FILE_UPLOAD.MAX_FILE_SIZE_INSTRUCTIONS':
        'Taille maximale du fichier : {maxSizeInMB} Mo.',
    'FILE_UPLOAD.MAX_FILE_SIZE_EXCEEDED':
        'Le fichier est trop grand. La taille maximale est : {size}',

    'FIELD.CREDIT_CARD_INFORMATION': 'Détails de la carte',
    'FIELD.NAME_ON_CARD': 'Nom sur la carte',
    'FIELD.CARD_NUMBER': 'Numéro',
    'FIELD.EXPIRY_MONTH_YEAR': 'Expiration',
    'FIELD.CVV': 'CVV',

    'FIELD.ORDER_ON_BEHALF_OF': 'Commander au nom de',

    'FIELD.REGISTERED_BUSINESS_NAME': "Nom déposé de l'entreprise",
    'FIELD.REGISTERED_BUSINESS_NUMBER': 'Numéro d’entreprise enregistré',
    'FIELD.ADDRESS_LINE_1': 'Unité / Appartement / Suite / Bâtiment',
    'FIELD.ADDRESS_LINE_2': 'Adresse de rue / Boîte postale',
    'FIELD.ADDRESS_LINE_3': 'Adresse Ligne 3',
    'FIELD.SUBURB': 'Ville / banlieue',
    'FIELD.STATE': 'État / province / région',
    'FIELD.POSTCODE': 'Code postal',
    'FIELD.COUNTRY': 'Pays',
    'FIELD.SHIPPERS': 'Transporteurs',

    'FIELD.NOTES': 'Remarques',
    'FIELD.NOTES.PLACEHOLDER': 'Rédigez vos remarques ici',

    'FIELD.BILLING_ADDRESS': 'Adresse de facturation',
    'FIELD.DELIVERY_ADDRESS': 'Adresse de livraison',
    'FIELD.DISCOUNT_CODE': 'Code de remise',
    'FIELD.PURCHASE_ORDER_NUMBER': 'Numéro du bon de commande',

    'FIELD.FREIGHT_DELIVERY_OPTION': 'Fret / Manutention',
    'FIELD.DELIVERY_OPTION': 'Option de livraison',
    'FIELD.URGENT_DELIVERY_PRIORITISATION': 'Priorisation des livraisons urgentes',
    'FIELD.ADDITIONAL_DELIVERY_NOTES': 'Notes de livraison supplémentaires',
    'FIELD.URGENT_DELIVERY_PRIORITISATION_WARNING': "La priorisation des livraisons urgentes n'a pas été mise en œuvre. Veuillez confirmer si nous faisons cela",
    'FIELD.APPLIED_DISCOUNT': 'Remise appliquée',
    'FIELD.IS_REQUIRED': 'Champ obligatoire',
    'FIELD.SOMETHING_WRONG': 'Quelque chose ne va pas avec le processus',
    'FIELD.PLEASE_CONFIRM_DOING': 'Veuillez confirmer si nous faisons cela à la caisse',

    'FIELD.ACCOUNT_DEPT_CONTACT': 'Nom du contact au service comptabilité',
    'FIELD.ACCOUNT_DEPT_EMAIL': 'Courriel du service comptabilité',
    'FIELD.ACCOUNT_DEPT_PHONE': 'Numéro de téléphone du service comptabilité',

    'FIELD.PURCHASE_DEPT_CONTACT': 'Nom du contact du service des achats',
    'FIELD.PURCHASE_DEPT_EMAIL': 'Courriel du service des achats',
    'FIELD.PURCHASE_DEPT_PHONE': 'Numéro de téléphone du service des achats',

    'FIELD.BSB': 'Code Swift',
    'FIELD.BSB_AU': 'BSB',
    'FIELD.BSB_CA': 'Numéro de routage',
    'FIELD.BANK_NAME': 'Nom de la banque',
    'FIELD.BANK_ACCOUNT_NAME': 'Nom du compte',
    'FIELD.BANK_ACCOUNT_NUMBER': 'Numéro de compte',
    'FIELD.BANK_SWIFT_CODE': 'Code Swift de la banque',
    'FIELD.BANK_SWIFT_CODE.TOOLTIP':
        'Le code Swift n’est pas nécessaire pour les comptes australiens.',

    'FIELD.SELECT_COUPON_USAGE': "Sélectionnez l'utilisation",
    'FIELD.SELECT_PIC_NUMBER': 'Sélectionnez numéro PIC',
    'FIELD.PREVIOUSLY_USED_PIC': 'PIC précédemment utilisé',
    'FIELD.PROPERTY_NAME': 'Nom de la propriété',
    'FIELD.OWNER_NAME': 'Nom du propriétaire',
    'FIELD.CONTINUE_SEQUENCE': 'Continuer la séquence ?',
    'FIELD.USE_PREFIX': 'Utiliser le préfixe',
    'FIELD.STEP': 'Valeur d’incrément',
    'FIELD.STEP.TOOLTIP':
        'La valeur ajoutée à votre numéro de départ par étiquette. Par exemple, si vous voulez que les étiquettes soient numérotées de 1 à 25, vous devez les incrémenter de un (valeur d’incrément).',
    'FIELD.PREFIX': 'Préfixe',
    'FIELD.PREFIX.TOOLTIP':
        "Cela ajoutera n'importe quel(s) caractère(s) avant votre numéro de séquence et sera fixé.",
    'FIELD.SUFFIX': 'Suffixe',
    'FIELD.SUFFIX.TOOLTIP':
        'Cela ajoutera n’importe quel caractère/s après votre numéro de séquence et sera corrigé.',
    'FIELD.SELECT_DISEASE_CODE': 'Sélectionnez Code des maladies',
    'FIELD.SELECT_DISEASE_CODE_NONE': 'Aucun',
    'FIELD.SELECT_PREFIX': 'Sélectionnez Préfixe',
    'FIELD.DISEASE_CODE': 'Code des maladies',
    'FIELD.RESELLER_PURCHASE_ORDER': 'Commande d’achat de revendeur',
    'FIELD.APPROVED_ON': 'Approuvé le',
    'FIELD.REJECTED_ON': 'Rejeté le',
    'FIELD.CONTACT_CUSTOMER_ON': 'Contactez le client au',
    'FIELD.BY': 'Par',
    'FIELD.ON': 'Sur',
    'FIELD.OFF_SHIPPING_AVAILABLE': 'DISPONIBLE HORS EXPÉDITION',
    'FIELD.COMBINED_TOTAL_NOT_EXCEED': 'Le total combiné de la remise client ne doit pas dépasser',
    'FIELD.VALUE_HAS_TO_BE': 'La valeur doit être',
    'FIELD.BETWEEN': 'entre',
    'FIELD.AND': 'et',
    'FIELD.AT_LEAST_THAN': 'au moins que',
    'FIELD.OR_LESS': 'ou moins',
    'FIELD.APPEARANCE': 'Apparence',
    'FIELD.CONTENT': 'Contenu',
    'FIELD.UPLOAD_IMAGE': 'Télécharger l’image',
    'FIELD.ONLY_SVG_WARNING': 'Seulement les fichiers *.svg seront acceptés',
    'FIELD.POSITION_OPTIONS': 'Options de position',
    'FIELD.SNAP_CENTER': 'Aligner sur le centre',
    'FIELD.OBJECT_RULES': 'Règles d’objet',
    'FIELD.START_NUMBER': 'Numéro de départ',
    'FIELD.COUNT': 'Compter',
    'FIELD.STEPS': 'Étape',
    'FIELD.SEQUENCE_PREVIEW': 'Aperçu de la séquence',
    'FIELD.COMBINED_DISCOUNT_TOTAL_NOT_EXCEED': 'Le total combiné du pourcentage de remise et de paiement des clients ne doit pas dépasser',
    'FIELD.NO_STORES_MATCHING': 'Aucun magasin correspondant à vos critères',
    'FIELD.FIND_NEAREST_STORE': 'Trouvez votre magasin et fournisseur le plus proche.',
    'FIELD.CHOOSE_OBJECT_TYPE': 'Choisissez le type d’objet',
    'FIELD.AWAITING_UPSTREAM_APPROVAL': 'En attente d’approbation en amont',
    'FIELD.DECLINED': 'Refusé',
    'FIELD.INCLUDE_BLANK': 'Inclure des espaces vierges',

    'FIELD.DAF_AUTHORISATION_NUMBER': "Numéro DAF (Ministère de l'agriculture et de la pêche)",
    'FIELD.DAF_AUTHORISATION_NUMBER.TOOLTIP':
        "Le numéro d'autorisation DAF est à usage unique. Votre commande ne peut être traitée sans le numéro d’autorisation DAF requis. Si vous n’avez pas de numéro d’autorisation DAF, veuillez cocher le champ ci-dessous pour que Leader Products l'obtienne pour vous.",
    'FIELD.DAF_AUTHORISATION_ISSUE_DATE': 'Date d’émission du DAF',
    'FIELD.DAF_AUTHORISATION_ISSUE_DATE.TOOLTIP':
        'La date d’autorisation du DAF est la date d’émission de votre formulaire d’autorisation DAF et est à usage unique.',
    'FIELD.DAF_AUTHORISATION_CHECKBOX':
        'Veuillez organiser une autorisation DAF pour ma commande.',

    'FIELD.USE_BRAND_OVER_PIC': 'Utiliser la marque et non le PIC',
    'FIELD.BRAND': 'Marque',
    'FIELD.LAZY_LETTER': 'Lazy Letter',
    'FIELD.LAZY_LETTER.OPTIONS.0': '0 (Aucun)',
    'FIELD.LAZY_LETTER.OPTIONS.1': '1 (Premier caractère)',
    'FIELD.LAZY_LETTER.OPTIONS.2': '2 (Deuxième caractère)',
    'FIELD.LAZY_LETTER.OPTIONS.3': '3 (Position centrale de la flèche)',

    'FIELD.TASMANIA_ID_NUMBER': 'Numéro d’identification de la Tasmanie',
    'FIELD.NAME_OF_PERSON_ORDERING': "Nom de l'auteur de la commande",

    'FIELD.CUSTOM_FIELD': 'Champ personnalisé',
    'FIELD.CURRENCY': 'Devise',

    'FIELD.MMT.INCLUDE_MMT': 'Inclure l’étiquette de gestion correspondante',
    'FIELD.MMT.MATCHING_TAG_SIZE': 'Taille d’étiquette assortie',
    'FIELD.MMT.COLOUR': 'Couleur',
    'FIELD.MMT.MARKING_TYPE': 'Type de marquage',
    'FIELD.MMT.PROPERTY_NAME': 'Nom de la propriété',
    'FIELD.MMT.VSPACETOOL': 'Lorem ipsum',
    'FIELD.MMT.MATCHING_MARKING': "Marquage de l'étiquette correspondante",
    'FIELD.ADD': 'Ajouter',
    'FIELD.ADD_LAYER_TYPE': 'Ajouter le type de couche',
    'FIELD.TYPES_MESSAGE': 'Vous avez déjà tous les types',
    'FIELD.CURVE_LAYER': 'Couche courbe',
    'FIELD.EXTRA_SETTINGS': 'Paramètres supplémentaires',
    'FIELD.NLIS_LABEL': 'Afficher ce champ personnalisé NLIS',
    'FIELD.MAX_WIDTH': 'Largeur maximale',
    'FIELD.POSITION': 'Position',
    'FIELD.BASIC_INFO': 'Informations de base',
    'FIELD.READ_ONLY_FIELD.LABEL': "Couche d'identification",
    'FIELD.SCALING': 'Échelle',
    'FIELD.GODAREA_EXPLANATION': "Tout ce qui se trouve dans cette zone n'est disponible qu'en mode SUPER ADMIN.",
    'FIELD.GODAREA_EXPLANATION_HINT': 'Si vous avez besoin que cette séquence soit une séquence NLIS, veuillez utiliser <strong>99999</strong>  pour le numéro de départ',
    'DIMENSIONS': 'Dimensions',

    'FIELD.TEXT_CONTENT': 'Contenu textuel',
    'FIELD.TEXT_CONTENT.TOOLTIP':
        "Tapez dans ce champ le texte que vous souhaitez voir apparaître sur votre étiquette. (Ce champ n'est pas incrémenté, il s'agit d'un champ de contenu fixe).",
    'FIELD.LINE_CONTENT': 'Contenu de la ligne',
    'FIELD.LINE_CONTENT.TOOLTIP':
        'Tapez ou coller une liste personnalisée dans le champ ci-dessous. Chaque ligne sera marquée sur une étiquette séparée.',
    'FIELD.LIST_CONTENT': 'Contenu de la ligne (1 élément par ligne)',
    'FIELD.LIST_CONTENT.ANIMATED_LABEL':
        'Copiez à partir de votre source et coller dans cette zone de texte',
    'FIELD.LIST_CONTENT.TOOLTIP':
        'Tapez ou coller une liste personnalisée dans le champ ci-dessous. Chaque ligne sera marquée sur une étiquette séparée.',
    'FIELD.FONT': 'Polices',
    'FIELD.SIZE': 'Taille',
    'FIELD.SPACING': 'Espacement',
    'FIELD.LEADING_ZEROS': 'Zéros initiaux',
    'FIELD.TEXT_ALIGNMENT': 'Alignement du texte',
    'FIELD.STARTING_NUMBER': 'Numéro de départ',
    'FIELD.STARTING_NUMBER.TOOLTIP':
        "C’est le premier numéro de votre séquence. Si vous voulez des zéros initiaux, saisissez-les avant votre numéro, par exemple si vous voulez un numéro à 4 chiffres commençant par 1, tapez 0001. Vous pouvez choisir de commencer par n'importe quel chiffre et il s'incrémentera sur vos étiquettes en fonction de votre quantité.",
    'FIELD.BARCODE_TYPE': 'Type de code à barres',
    'FIELD.CODE_CONTENT': 'Contenu du code',

    // Facteur de champ
    'FIELD.POSTMAN.access_key': 'Clé d’accès',
    'FIELD.POSTMAN.account': 'Compte',
    'FIELD.POSTMAN.account_code': 'Code de compte',
    'FIELD.POSTMAN.account_id': 'Identifiant du compte',
    'FIELD.POSTMAN.account_number': 'Numéro de compte',
    'FIELD.POSTMAN.account_pin': 'Code PIN du compte',
    'FIELD.POSTMAN.account_entity': 'Entité du compte',
    'FIELD.POSTMAN.aes_key': 'Clé AES (norme de chiffrement avancé)',
    'FIELD.POSTMAN.agent_id': 'Identifiant de l’agent',
    'FIELD.POSTMAN.agent_code': 'Code de l’agent',
    'FIELD.POSTMAN.application_id': 'Identifiant de l’application',
    'FIELD.POSTMAN.application_token': 'Jeton de l’application',
    'FIELD.POSTMAN.api_customer_number': 'Numéro de client API',
    'FIELD.POSTMAN.apikey': 'Clé API',
    'FIELD.POSTMAN.api_key': 'Clé API',
    'FIELD.POSTMAN.api_secret': 'API Secret',
    'FIELD.POSTMAN.api_token': 'Jeton API',
    'FIELD.POSTMAN.authorization_code': 'Code d’autorisation',
    'FIELD.POSTMAN.billing_account_id': 'Identifiant du compte de facturation',
    'FIELD.POSTMAN.billing_register_number': 'Numéro de registre de facturation',
    'FIELD.POSTMAN.branch_code': 'Code succursale',
    'FIELD.POSTMAN.carrier_facility_id': 'Identifiant de l’installation du transporteur',
    'FIELD.POSTMAN.ccc': 'CCC',
    'FIELD.POSTMAN.check_word': 'Vérifier le mot',
    'FIELD.POSTMAN.ci': 'CI',
    'FIELD.POSTMAN.client_code': 'Code client',
    'FIELD.POSTMAN.client_id': 'Identifiant du client',
    'FIELD.POSTMAN.client_facility_id': 'Identifiant de l’installation client',
    'FIELD.POSTMAN.client_name': 'Nom du client',
    'FIELD.POSTMAN.client_number': 'Numéro de client',
    'FIELD.POSTMAN.cod_customer_code': 'Code client contre-remboursement',
    'FIELD.POSTMAN.company_id': 'Identifiant de l’entreprise',
    'FIELD.POSTMAN.consignorid': "Identifiant de l'expéditeur",
    'FIELD.POSTMAN.consignorname': "Nom de l'expéditeur",
    'FIELD.POSTMAN.contract_id': 'Identifiant du contrat',
    'FIELD.POSTMAN.contract_number': 'Numéro de contrat',
    'FIELD.POSTMAN.cost_center': 'Centre des coûts',
    'FIELD.POSTMAN.currency': 'Devise',
    'FIELD.POSTMAN.customercode': 'Code client',
    'FIELD.POSTMAN.customer_code': 'Code client',
    'FIELD.POSTMAN.customer_number': 'Numéro de client',
    'FIELD.POSTMAN.delis_user_id': "Identifiant de l'utilisateur Delis",
    'FIELD.POSTMAN.developer_id': 'Identifiant du développeur',
    'FIELD.POSTMAN.developer_pin': 'Code PIN du développeur',
    'FIELD.POSTMAN.dispatch_depot': "Entrepôt d'expédition",
    'FIELD.POSTMAN.ec_ship_username': 'Nom d’utilisateur EC Ship',
    'FIELD.POSTMAN.entity_id': 'Identifiant de l’entité',
    'FIELD.POSTMAN.entity_pin': "Code PIN de l'entité",
    'FIELD.POSTMAN.ftp_username': 'Nom d’utilisateur FTP',
    'FIELD.POSTMAN.ftp_password': 'Mot de passe FTP',
    'FIELD.POSTMAN.hmac_sha512_key': 'Clé HMAC SHA512',
    'FIELD.POSTMAN.hub_id': 'Identifiant du Hub',
    'FIELD.POSTMAN.identity': 'Identité',
    'FIELD.POSTMAN.key': 'Clé',
    'FIELD.POSTMAN.key_password': 'Mot de passe clé',
    'FIELD.POSTMAN.labeller_code': "Code de l'étiqueteur",
    'FIELD.POSTMAN.language': 'Langue',
    'FIELD.POSTMAN.licence_key': 'Clé de licence',
    'FIELD.POSTMAN.license_key': 'Clé de licence',
    'FIELD.POSTMAN.login_id': 'Identifiant de connexion',
    'FIELD.POSTMAN.merchant_id': 'Identifiant du vendeur',
    'FIELD.POSTMAN.meter_number': 'Numéro de compteur',
    'FIELD.POSTMAN.nif': 'NIF',
    'FIELD.POSTMAN.number_of_franchise': 'Nombre de franchises',
    'FIELD.POSTMAN.origin_code': 'Code d’origine',
    'FIELD.POSTMAN.partner_id': 'Identifiant du partenaire',
    'FIELD.POSTMAN.partner_token': 'Jeton partenaire',
    'FIELD.POSTMAN.password': 'Mot de passe',
    'FIELD.POSTMAN.passphrase': 'Phrase secrète',
    'FIELD.POSTMAN.pickup_account_id': 'Identifiant du compte de ramassage',
    'FIELD.POSTMAN.pickup_name': 'Nom de ramassage',
    'FIELD.POSTMAN.prepaid_customer_code': 'Code du client prépayé',
    'FIELD.POSTMAN.ppi': 'PPI',
    'FIELD.POSTMAN.return_instructions': 'Instructions pour le retour',
    'FIELD.POSTMAN.site_id': 'Identifiant du site',
    'FIELD.POSTMAN.site_code': 'Code du site',
    'FIELD.POSTMAN.shipby_address_code': 'Code adresse expédier par',
    'FIELD.POSTMAN.shipment_id_prefix': "Préfixe d'identification de l'envoi",
    'FIELD.POSTMAN.shipper_id': "Identifiant de l'expéditeur",
    'FIELD.POSTMAN.shipper_num': 'Numéro de l’expéditeur',
    'FIELD.POSTMAN.shipper_rate_plan': "Plan tarifaire de l'expéditeur",
    'FIELD.POSTMAN.token': 'Jeton',
    'FIELD.POSTMAN.user_email': 'Courriel de l’utilisateur',
    'FIELD.POSTMAN.user_identifier': "Identifiant de l'utilisateur",
    'FIELD.POSTMAN.username': "Nom d'utilisateur",
    'FIELD.POSTMAN.usps_endorsement': 'Approbation de l’USPS',

    'FIELD.POSTMAN.TrackingUrl': 'URL de suivi',
    'FIELD.POSTMAN.PriceConversionRate': 'Taux de conversion des prix',
    'FIELD.POSTMAN.PriceConversionEnabled': 'Conversion des prix activée',
    'FIELD.POSTMAN.Manifestable': 'Manifestable',
    'FIELD.POSTMAN.DangerousGoods': 'Marchandises dangereuses',

    // Étiquette Stripe par défaut
    // Stripe - Coordonnées bancaires
    'FIELD.STRIPE.StripeBSB': 'Code Swift',
    'FIELD.STRIPE.StripeBankAccountHolderName': 'Nom du titulaire du compte',
    'FIELD.STRIPE.StripeBankAccountNumber': 'Numéro de compte',
    'FIELD.STRIPE.StripeDOB': 'Date de naissance',
    'FIELD.STRIPE.StripeIdentityCardNumber': 'Numéro HKID',
    'FIELD.STRIPE.StripeCompany_BusinessName': 'Nom d’entreprise',
    'FIELD.STRIPE.StripeCompany_TaxId': 'Numéro d’entreprise (Identifiant fiscal)',
    'FIELD.STRIPE.StripeFirstName': 'Prénom',
    'FIELD.STRIPE.StripeSurname': 'Nom',
    'FIELD.STRIPE.StripeEmail': 'Courriel',
    'FIELD.STRIPE.StripePhone': 'Téléphone',
    'FIELD.STRIPE.StripeAddressStreetNumber': 'Numéro de rue de l’entreprise',
    'FIELD.STRIPE.StripeAddressSuburb': 'Ville d’entreprise / banlieue',
    'FIELD.STRIPE.StripeAddressState': 'État / province / région de l’entreprise',
    'FIELD.STRIPE.StripeAddressPostalCode': "Code postal de l'entreprise",
    'FIELD.STRIPE.StripeDocFront': 'Recto du document de vérification',
    'FIELD.STRIPE.StripeDocBack': 'Verso du document de vérification',
    'FIELD.STRIPE.StripeAdditionalDocFront': 'Recto du document supplémentaire',
    'FIELD.STRIPE.StripeAdditionalDocBack': 'Verso du document supplémentaire',

    'FIELD.STRIPE.StripeBusinessProfile_Mcc': 'Profil d’affaires MCC',
    'FIELD.STRIPE.StripeBusinessProfile_Url': 'URL du profil d’entreprise',

    'FIELD.STRIPE.StripeCompany_Phone': 'Téléphone de l’entreprise',
    'FIELD.STRIPE.StripeCompany_AddressStreetNumber': 'Numéro de rue de l’entreprise',
    'FIELD.STRIPE.StripeCompany_AddressSuburb': 'Ville d’entreprise / banlieue',
    'FIELD.STRIPE.StripeCompany_AddressState':
        'État / province / région de l’entreprise',
    'FIELD.STRIPE.StripeCompany_AddressPostalCode': "Code postal de l'entreprise",
    'FIELD.STRIPE.StripeCompany_DocFront':
        "Recto du document de vérification de l'entreprise",
    'FIELD.STRIPE.StripeCompany_DocBack': "Verso du document de vérification de l'entreprise",

    // Détails du représentant
    'FIELD.STRIPE.StripeRepresentative_FirstName': 'Prénom du représentant',
    'FIELD.STRIPE.StripeRepresentative_Surname': 'Nom de famille du représentant',
    'FIELD.STRIPE.StripeRepresentative_Gender': 'Sexe du représentant',
    'FIELD.STRIPE.StripeRepresentative_DOB': 'Date de naissance du représentant',
    'FIELD.STRIPE.StripeRepresentative_Email': 'Courriel du représentant',
    'FIELD.STRIPE.StripeRepresentative_Phone': 'Téléphone du représentant',
    'FIELD.STRIPE.StripeRepresentative_IdentityCardNumber':
        'Numéro de carte d’identité du représentant',
    'FIELD.STRIPE.StripeRepresentative_SSN':
        'Numéro de sécurité sociale du représentant',
    'FIELD.STRIPE.StripeRepresentative_RelationshipTitle':
        'Titre de la relation du représentant',
    'FIELD.STRIPE.StripeRepresentative_AddressStreetNumber':
        'Numéro de rue du représentant',
    'FIELD.STRIPE.StripeRepresentative_AddressPostalCode':
        'Code postal du représentant',
    'FIELD.STRIPE.StripeRepresentative_AddressSuburb':
        'Ville / banlieue du représentant',
    'FIELD.STRIPE.StripeRepresentative_State':
        'État représentatif / Province / Région',
    'FIELD.STRIPE.StripeRepresentative_DocFront':
        'Document de vérification du représentant recto',
    'FIELD.STRIPE.StripeRepresentative_DocBack':
        'Document de vérification du représentant verso',
    'FIELD.STRIPE.StripeRepresentative_AdditionalDocFront':
        'Recto de document supplémentaire du représentant',
    'FIELD.STRIPE.StripeRepresentative_AdditionalDocBack':
        'Document supplémentaire du représentant verso',

    // Détails du directeur
    'FIELD.STRIPE.StripeDirector_FirstName': 'Prénom du directeur',
    'FIELD.STRIPE.StripeDirector_Surname': 'Nom de famille du directeur',
    'FIELD.STRIPE.StripeDirector_Gender': 'Directeur Genre',
    'FIELD.STRIPE.StripeDirector_DOB': 'Date de naissance du directeur',
    'FIELD.STRIPE.StripeDirector_Email': 'Courriel du directeur',
    'FIELD.STRIPE.StripeDirector_Phone': 'Téléphone directeur',
    'FIELD.STRIPE.StripeDirector_IdentityCardNumber':
        'Numéro de carte d’identité du directeur',
    'FIELD.STRIPE.StripeDirector_SSN': 'Directeur Numéro de sécurité sociale',
    'FIELD.STRIPE.StripeDirector_RelationshipTitle':
        'Titre de la relation directeur',
    'FIELD.STRIPE.StripeDirector_AddressStreetNumber': 'Numéro de rue du directeur',
    'FIELD.STRIPE.StripeDirector_AddressPostalCode':
        'Code postal du directeur',
    'FIELD.STRIPE.StripeDirector_AddressSuburb': 'Directeur Ville / Banlieue',
    'FIELD.STRIPE.StripeDirector_State': 'Directeur État / Province / Région',
    'FIELD.STRIPE.StripeDirector_DocFront':
        'Document de vérification du directeur recto',
    'FIELD.STRIPE.StripeDirector_DocBack':
        'Document de vérification du directeur verso',
    'FIELD.STRIPE.StripeDirector_AdditionalDocFront':
        'Directeur Supplémentaire Document recto',
    'FIELD.STRIPE.StripeDirector_AdditionalDocBack':
        'Directeur Document supplémentaire verso',

    // Détails du propriétaire
    'FIELD.STRIPE.StripeOwner_FirstName': 'Prénom du propriétaire',
    'FIELD.STRIPE.StripeOwner_Surname': 'Nom de famille du propriétaire',
    'FIELD.STRIPE.StripeOwner_Gender': 'Sexe du propriétaire',
    'FIELD.STRIPE.StripeOwner_DOB': 'Date de naissance du propriétaire',
    'FIELD.STRIPE.StripeOwner_Email': 'Courriel du propriétaire',
    'FIELD.STRIPE.StripeOwner_Phone': 'Téléphone propriétaire',
    'FIELD.STRIPE.StripeOwner_IdentityCardNumber': 'Numéro de carte d’identité du propriétaire',
    'FIELD.STRIPE.StripeOwner_SSN': 'Numéro de sécurité sociale propriétaire',
    'FIELD.STRIPE.StripeOwner_RelationshipTitle': 'Titre de la relation propriétaire',
    'FIELD.STRIPE.StripeOwner_AddressStreetNumber': 'Numéro de rue du propriétaire',
    'FIELD.STRIPE.StripeOwner_AddressPostalCode': 'Code postal du propriétaire',
    'FIELD.STRIPE.StripeOwner_AddressSuburb': 'Ville / banlieue du propriétaire',
    'FIELD.STRIPE.StripeOwner_State': 'État propriétaire / Province / Région',
    'FIELD.STRIPE.StripeOwner_DocFront': 'Document de vérification du propriétaire recto',
    'FIELD.STRIPE.StripeOwner_DocBack': 'Document de vérification du propriétaire verso',
    'FIELD.STRIPE.StripeOwner_AdditionalDocFront':
        'Document supplémentaire du propriétaire recto',
    'FIELD.STRIPE.StripeOwner_AdditionalDocBack':
        'Propriétaire Document supplémentaire verso',

    // Étiquette AU Stripe
    'FIELD.STRIPE.StripeBSB.en_AU': 'BSB',
    'FIELD.STRIPE.StripeBankAccountNumber.en_AU': 'Numéro de compte bancaire',
    'FIELD.STRIPE.StripeCompany_TaxId.en_AU': 'ABN (ID fiscal)',

    // Étiquette CA Stripe
    'FIELD.STRIPE.StripeBSB.en_CA': 'Numéro de routage',
    'FIELD.STRIPE.StripeBankAccountNumber.en_CA': 'Numéro de compte',
    'FIELD.STRIPE.StripeCompany_TaxId.en_CA': 'Numéro d’entreprise (Identifiant fiscal)',
    'FIELD.STRIPE.StripeBSB.StripeToolTip.en_CA':
        'FORMAT DU NUMÉRO DE ROUTAGE : 00000-000',
    'FIELD.STRIPE.StripeBankAccountNumber.StripeToolTip.en_CA':
        'FORMAT DU NUMÉRO DE COMPTE : 0000000',

    'STRIPE_CONNECT_FORM.SUCCESS.HEADING':
        'La configuration de paiement de votre compte est validée',
    'STRIPE_CONNECT_FORM.SUCCESS.CONTENT':
        'Votre profil Stripe Connect est terminé. Il y a une chance qu’ils nécessitent une vérification plus approfondie à l’avenir. Vous serez invité ici pour plus de détails si cela se produit.',
    'STRIPE_CONNECT_FORM.SUCCESS.EDIT_BANK.HEADING':
        'La configuration de paiement de votre compte est validée',
    'STRIPE_CONNECT_FORM.SUCCESS.EDIT_BANK.SUBHEADING':
        'Coordonnées bancaires : {countryCode}',
    'STRIPE_CONNECT_FORM.SUCCESS.EDIT_BANK.CONTENT':
        'Votre compte a été vérifié et configuré avec succès pour recevoir des paiements. Comme nous utilisons Stripe Connect pour les paiements, il y a une chance qu’ils peuvent nécessiter une vérification plus approfondie à l’avenir. Vous serez invité ici pour plus de détails si cela se produit.',
    'STRIPE_CONNECT_FORM.WARNING.HEADING':
        'Votre compte n’est pas configuré pour recevoir des paiements',
    'STRIPE_CONNECT_FORM.WARNING.SUBHEADING': 'Coordonnées bancaires : {countryCode}',
    'STRIPE_CONNECT_FORM.WARNING.CONTENT':
        "Please enter the bank account details where you wish to receive automated payments from your Customers' online orders. This can be changed later after verification.",
    'STRIPE_CONNECT_FORM.WARNING_STRIPE.HEADING':
        'Votre compte nécessite une vérification supplémentaire pour recevoir les paiements',
    'STRIPE_CONNECT_FORM.WARNING_STRIPE.CONTENT':
        'Comme nous utilisons Stripe Connect pour les paiements, il a été noté que des informations de vérification supplémentaires sont nécessaires avant que vous puissiez recevoir des paiements. Veuillez continuer vers Stripe et suivez les invites afin de terminer votre configuration.',
    'STRIPE_CONNECT_FORM.WARNING_STRIPE.BUTTON': 'Continuer à Stripe',
    'STRIPE_CONNECT_FORM.ERROR_TOKEN': "Impossible d'obtenir le jeton",
    'STRIPE_CONNECT_FORM.ERROR_JS_LOADED': "Stripe.js n'est pas encore chargé.",
    'STRIPE_CONNECT_FORM.HAS_BEEN_PAID': 'a été payé avec succès',
    'STRIPE_CONNECT_FORM.MANUAL_VERIFICATION': 'Vérification manuelle requise',
    'STRIPE_CONNECT_FORM.MARK_PAID': 'Marqué comme payé',
    'STRIPE_CONNECT_FORM.TOTAL_OWING': 'Total dû',
    'STRIPE_CONNECT_FORM.PAYING TODAY': 'PAYER AUJOURD’HUI',
    'STRIPE_CONNECT_FORM.USED_REFERENCE_MESSAGE': 'J’ai utilisé ce numéro de référence',

    'STRIPE_CONNECT_FORM.EMPTY_MESSAGE':
        'Il semble que vous n’avez pas de configuration Stripe qui a besoin d’attention.',
    'STRIPE_CONNECT_FORM.BUSINESS_PROFILE.HEADING': 'Profil d’entreprise',
    'STRIPE_CONNECT_FORM.COMPANY.HEADING': 'Société',
    'STRIPE_CONNECT_FORM.REPRESENTATIVE.HEADING': 'Représentant',
    'STRIPE_CONNECT_FORM.DIRECTOR.HEADING': 'Directeur',
    'STRIPE_CONNECT_FORM.OWNER.HEADING': 'Propriétaire',

    'STRIPE_COUNTRY_FORM.HEADING':
        'Votre compte n’est pas configuré pour recevoir des paiements',
    'STRIPE_COUNTRY_FORM.SUBHEADING': 'Sélectionnez Pays',
    'STRIPE_COUNTRY_FORM.CONTENT':
        'Afin de recevoir des paiements, vous devez compléter la configuration de votre compte avec Stripe. S’il vous plaît commencer le processus en sélectionnant votre pays. S’il vous plaît noter que vous ne pouvez pas changer votre pays après avoir enregistré.',

    'STRIPE_CONNECT_FORM.MISSING_FIELDS': 'Votre Stripe a encore des champs manquants. Veuillez le remplir pour activer votre compte.',
    'STRIPE_CONNECT_FORM.FIELDS_HEADING': 'S’il vous plaît compléter les champs suivants',
    'STRIPE_CONNECT_FORM.LETS_GO': 'Allons-y',
    'STRIPE_CONNECT_FORM.SELECT_COUNTRY': 'Sélectionnez un pays',
    'STRIPE_CONNECT_FORM.SELECT_CURRENCY': 'Sélectionnez une devise',

    'CREDIT_CARD_FORM.CURRENT_BILLING_ADDRESS': 'Votre adresse de facturation actuelle',
    'CREDIT_CARD_FORM.NO_CURRENT_BILLING_ADDRESS':
        "You don't have a default billing address",

    'CHECKOUT.RECIPIENT_INFORMATION.CHANGE_DETAIL_CONTENT':
        'Modifiez vos informations dans <a href="/account/details">les détails de votre compte</a>',

    'CHECKOUT.DISCOUNT_CODE.HEADING': 'Code de remise',

    'CHECKOUT.PURCHASE_ORDER_NUMBER.HEADING': 'Numéro du bon de commande',

    'CHECKOUT.BILLING_ADDRESS.HEADING': 'Adresse de facturation',
    'CHECKOUT.DISPATCH_LOCATION.HEADING': "Lieu d'expédition",
    'CHECKOUT.BILLING_ADDRESS.MESSAGE':
        'Lorem ipsum dolor sit amet, consecteturadipiscingelit. Aeneaneuismod bibendum laoreet. Proingravidadolorsitametlacusaccumsan et viverrajusto commodo.',

    'CHECKOUT.DELIVERY_ADDRESS.HEADING': 'Adresse de livraison',
    'CHECKOUT.DELIVERY_ADDRESS.MESSAGE':
        'Lorem ipsum dolor sit amet, consecteturadipiscingelit. Aeneaneuismod bibendum laoreet. Proingravidadolorsitametlacusaccumsan et viverrajusto commodo.',
    'CHECKOUT.DELIVERY_ADDRESS.NO_ADDRESS':
        "You don't have a selected delivery address",

    'PAYMENT_FORM.CREDIT_CARD.LOCKED_AMOUNT':
        'Cette commande sera payée à l’aide des données stockées de la carte de crédit.',
    'PAYMENT_FORM.CREDIT_CARD.REQUIRE_CREDIT_CARD':
        'Vous devrez fournir les détails de votre carte de crédit',
    'PAYMENT_FORM.CHARGE_ACCOUNT.HEADING':
        'Cette commande sera ajoutée à votre compte.',
    'PAYMENT_FORM.CHARGE_ACCOUNT.CONTENT_WHOLESALER':
        'Si vous avez un identifiant de compte, veuillez le saisir ici.',
    'PAYMENT_FORM.CHARGE_ACCOUNT.CONTENT_RESELLER':
        'Si vous avez un identifiant de compte, veuillez le saisir ici.',
    'PAYMENT_FORM.CHARGE_ACCOUNT.CONTENT_CUSTOMER':
        'Si vous avez un identifiant de compte, veuillez le saisir ici.',

    'PAYMENT_FORM.CHARGE_ACCOUNT.CONTENT_BANK_TRANSFER':
        'Après avoir soumis votre commande, vous recevrez un courriel avec les instructions de virement bancaire. Votre facture peut également être consultée à tout moment dans la section Mon compte > Factures.',

    'PAYMENT_FORM.PAYMENT_METHOD_WARNING': 'Vous n’avez pas de mode de paiement disponible.',

    AWAITING_APPROVAL: 'En attente d’approbation',

    UNPACKED: 'Déballé',
    PACKED: 'Emballé',
    READY_FOR_COLLECTION: 'Prêt pour la collection',

    REGISTERED_CUSTOMERS: 'Clients inscrits',
    REGISTERED_RESELLERS: 'Revendeurs enregistrés',
    EMAIL: 'Courriel',
    EMAIL_OR_USERNAME: 'Courriel / Nom d’utilisateur',
    REGISTERED: 'Enregistré',
    MEMBER_SINCE: 'Membre Depuis',
    ACTION: 'Action',
    ADD_NEW_CUSTOMER: 'Ajouter un nouveau client',
    ADD_NEW_RESELLER: 'Ajouter un nouveau revendeur',
    APPROVE_REJECT: 'Approuver / Rejeter',

    PROCESS_PAYMENT: 'Processus de paiement',
    PROCESS_PAYMENT_CARD: 'Processus de paiement',
    PROCESS_PAYMENT_BANK: 'Marque tel que payé',

    PROCESS_PAYMENT_BANK_DESCRIPTION_DEFAULT:
        'Le total de votre commande doit être versé sur le compte suivant, le numéro de référence doit être inclus pour que votre paiement soit reconnu.',
    PROCESS_PAYMENT_BANK_DESCRIPTION_SELECTED:
        'Pour payer une facture via le virement bancaire, vous devez d’abord sélectionner une facture de la liste, puis transférer le montant en utilisant les coordonnées bancaires et le numéro de référence fournis, et le clic « MARQUER COMME PAYÉ».',

    // Formulaire de détails de compte
    'ACCOUNT_HOLDER_INFORMATION_FORM.HEADING': 'Informations sur les titulaires de compte',
    'ACCOUNT_HOLDER_INFORMATION_FORM.CUSTOMER_ID': 'Identifiant du client',
    'ACCOUNT_HOLDER_INFORMATION_FORM.CUSTOMER_EXO_ID': 'Identifiant du',
    'ACCOUNT_HOLDER_INFORMATION_FORM.CUSTOM_WEBSTORE_CODE':
        'Code Webstore personnalisé',
    'ACCOUNT_HOLDER_INFORMATION_FORM.SUCCESS_MESSAGE':
        'Vos informations ont été mises à jour',
    'ACCOUNT_HOLDER_INFORMATION_FORM.SUCCESS_MESSAGE_EMAIL':
        'Un courriel pour confirmer la mise à jour de votre courriel a été envoyé',

    'ACCOUNT_ADDRESS.HEADING': 'Vos adresses de livraison',
    'ACCOUNT_ADDRESS.CONTENT.CUSTOMER':
        'Ici, vous pouvez consulter une liste de toutes vos adresses de livraison et de facturation. Vous pouvez également ajouter ou supprimer une adresse et définir votre adresse de facturation préférée.',
    'ACCOUNT_ADDRESS.CONTENT.RESELLER':
        'Ici, vous pouvez consulter une liste de toutes vos adresses de livraison et de facturation. Vous pouvez également ajouter ou supprimer une adresse et définir votre adresse de facturation préférée.',
    'ACCOUNT_ADDRESS.CONTENT.WHOLESALER':
        'Ici, vous pouvez consulter une liste de toutes vos adresses de livraison et de facturation. Vous pouvez également ajouter ou supprimer une adresse et définir votre adresse de facturation préférée.',
    'ACCOUNT_ADDRESS.ADD_NEW': 'Ajouter une nouvelle adresse',

    'ACCOUNT_BUSINESS_ADDRESS.HEADING': 'Adresse du siège social',
    'ACCOUNT_BUSINESS_ADDRESS.CONTENT':
        'Lorem ipsum dolor sit amet, consecteturadipiscingelit. Aliquamcondimentumlorem in est sodales.',
    'ACCOUNT_BUSINESS_ADDRESS.HEADING.WHOLESALER': "Adresse du lieu d'expédition",
    'ACCOUNT_BUSINESS_ADDRESS.CONTENT.WHOLESALER':
        "Veuillez saisir dans le localisateur d'adresses ci-dessous l'adresse que vous utiliserez lors de l'expédition de vos produits aux revendeurs ou aux clients particuliers recommandés. L’adresse doit être précise car elle sera utilisée pour calculer automatiquement les prix de fret à vos clients. Le cas échéant, vous devez également saisir votre unité / appartement / suite / numéro de bâtiment, etc.",
    'ACCOUNT_BUSINESS_ADDRESS.HEADING.RESELLER': 'Détails de votre localisateur de magasin',
    'ACCOUNT_BUSINESS_ADDRESS.CONTENT.RESELLER':
        "Veuillez saisir dans le localisateur d'adresse ci-dessous l'adresse que vous souhaitez voir affichée à un client particulier recommandé lors de la procédure d'inscription de votre magasin revendeur. Le cas échéant, vous devez également saisir votre unité / appartement / suite / numéro de bâtiment, etc.",

    'ACCOUNT_POSTMEN.HEADING': 'Transporteurs de fret',
    'ACCOUNT_POSTMEN.CONTENT':
        'Ici, vous pouvez gérer les transporteurs disponibles pour tous vos revendeurs et clients particuliers. Vous avez la possibilité de modifier, supprimer ou ajouter de nouveaux transporteurs ci-dessous.',
    'ACCOUNT_POSTMEN.ADD_NEW': 'Ajouter un nouveau transporteur',
    'ACCOUNT_POSTMEN.SELECT_CARRIER': 'Sélectionnez un transporteur',

    'ACCOUNT_CARTRULE.HEADING': 'Remise d’expédition',
    'ACCOUNT_CARTRULE.CONTENT': 'Description de la règle du panier',
    'ACCOUNT_CARTRULE.ADD_NEW': "Ajouter une nouvelle remise sur les frais d'expédition",

    'ACCOUNT_EMAIL_FORM.HEADING': 'Modifier le courriel',

    'ACCOUNT_STRIPE_CREDENTIALS_FORM.HEADING': 'Identifiants Stripe',
    'ACCOUNT_STRIPE_CREDENTIALS_FORM.CONTENT':
        'Vous pouvez modifier vos informations d’identification en complétant les deux champs ci-dessous',

    'ACCOUNT_PASSWORD_FORM.HEADING': 'Changer de mot de passe',
    'ACCOUNT_PASSWORD_FORM.CONTENT':
        'Vous pouvez modifier votre mot de passe en complétant les deux champs ci-dessous',

    'ACCOUNT_RESELLER_ACCOUNT_DEPT_FORM.HEADING': 'Informations sur le service comptabilité',
    'ACCOUNT_RESELLER_PURCHASE_DEPT_FORM.HEADING':
        'Informations sur le service des achats',

    'ACCOUNT_GOVERNMENT_DETAILS_FORM.HEADING':
        "Détails de l'enregistrement auprès du gouvernement",

    'ACCOUNT_BANK_INFORMATION_FORM.HEADING': 'Coordonnées bancaires',
    'ACCOUNT_BANK_INFORMATION_FORM.CONTENT.RESELLER':
        'Les coordonnées bancaires ci-dessous sont indiquées à vos clients pour tout paiement de commande ou de facture effectué par virement bancaire. Pour les paiements automatiques Stripe, vous serez invité à saisir plus de détails à la fin de votre inscription.',

    'ACCOUNT_PIC_NUMBER.HEADING':
        "Détails du code d'identification de la propriété (PIC) NLIS",
    'ACCOUNT_PIC_NUMBER.CONTENT':
        "Voici une liste des numéros PIC que vous avez déjà utilisés dans l’éditeur d'étiquettes NLIS.",
    'ACCOUNT_PIC_NUMBER.ADD_NEW': 'Ajouter le numéro du code PIC',

    'ACCOUNT_BILLING_ADDRESS.HEADING': 'Adresse de facturation',

    'ACCOUNT_CREDIT_CARD.HEADING': 'Cartes enregistrées',
    'ACCOUNT_CREDIT_CARD.CONTENT':
        'Ici, vous pouvez gérer toutes vos cartes de crédit enregistrées, et sélectionner la valeur par défaut à utiliser pendant le processus de paiement.',
    'ACCOUNT_CREDIT_CARD.ADD_NEW': 'Ajouter une nouvelle carte',

    'ACCOUNT_RESELLER.HEADING': 'Revendeurs attribués',
    'ACCOUNT_RESELLER.CONTENT':
        'Ici, vous pouvez gérer tous vos revendeurs nominés, et afficher le numéro de compte attribué utilisé lors du placement de commandes sur le compte.',
    'ACCOUNT_RESELLER.ADD_NEW': 'Ajouter un nouveau revendeur',

    'ACCOUNT_WHOLESALER.HEADING': 'Grossistes attribués',
    'ACCOUNT_WHOLESALER.CONTENT':
        'Vous avez la possibilité de changer votre grossiste ci-dessous. [Veuillez noter que cela affectera la gamme actuelle de stocks disponibles pour vos clients de détail.]',
    'ACCOUNT_WHOLESALER.ADD_NEW': 'Ajouter un nouveau grossiste',

    'ACCOUNT_QUECLINK.HEADING': 'Compte Queclink',
    'ACCOUNT_QUECLINK.CONTENT':
        'Ici, vous pouvez afficher le nom de votre compte et le numéro de compte attribué pour les commandes passées à Queclink.',
    'ACCOUNT_QUECLINK.ADD_NEW': 'Ajouter un nouveau revendeur',

    'ACCOUNT_REFERRAL_COUPON.HEADING': 'Coupons de recommandation',
    'ACCOUNT_REFERRAL_COUPON.CONTENT': '',
    'ACCOUNT_REFERRAL_COUPON.ADD_NEW': 'Ajouter un nouveau coupon',

    'ACCOUNT_RESELLER_PAYMENT_METHODS_FORM.HEADING': 'Options de paiement',
    'ACCOUNT_RESELLER_PAYMENT_METHODS_FORM.CONTENT':
        'Veuillez sélectionner les options de paiement que vous souhaitez mettre à la disposition de vos clients particuliers au moment du paiement.',

    ADD_NEW_ASSIGNED_WHOLESALER: 'Ajouter le nouveau grossiste assigné',
    ADD_NEW_ASSIGNED_RESELLER: 'Ajouter le nouveau revendeur assigné',
    ADD_NEW_ASSIGNED_SUPPLIER: 'Ajouter le nouveau fournisseur assigné',

    ASSIGNED_ACCOUNT_NUMBER: 'Numéro de compte attribué',
    ADD_NEW_ADDRESS: 'Ajouter une nouvelle adresse',
    ADD_NEW_POSTMAN: 'Ajouter un nouveau transporteur',
    ADD_NEW_CARTRULE: "Ajouter une nouvelle remise sur les frais d'expédition",
    EDIT_POSTMAN: 'Modifier le transporteur',
    EDIT_CARTRULE: 'Modifier la règle du panier',
    ADD_NEW_BILLING_ADDRESS: 'Ajouter une nouvelle adresse de facturation',
    ADD_NEW_DELIVERY_ADDRESS: 'Ajouter une nouvelle adresse de livraison',
    REGISTERED_BUSINESS_NAME: "Nom déposé de l'entreprise",

    RESELLER_NAME: 'Nom du compte',
    WHOLESALER_NAME: 'Nom du grossiste',
    SUPPLIER_NAME: 'Nom du fournisseur',

    // Assistant d'étiquettes
    'TAG_WIZARD.EMPTY_PRODUCT.HEADING': 'Ce produit n’est pas disponible',
    'TAG_WIZARD.EMPTY_PRODUCT.CONTENT':
        'Ce produit n’est pas disponible dans votre région.',

    'TAG_WIZARD.TAG_USAGE.HEADING': 'Choisissez l’utilisation de l’étiquette',
    'TAG_WIZARD.TAG_USAGE.NLIS': 'NLIS',
    'TAG_WIZARD.TAG_USAGE.TAG_EDITOR': "Éditeur d'étiquettes",
    'TAG_WIZARD.TAG_USAGE.BLANK_TAG': 'Étiquette vierge',

    'TAG_WIZARD.TAG_COLOUR.HEADING': 'Couleurs',
    'TAG_WIZARD.TAG_COLOUR.COLOURS': 'Couleurs',
    'TAG_WIZARD.TAG_COLOUR.COLOUR': 'Couleur',

    'TAG_WIZARD.PRINTING_METHOD.HEADING': 'Méthode de marquage',
    'TAG_WIZARD.PRINTING_METHOD.OPTIONS.Laser': 'Laser',
    'TAG_WIZARD.PRINTING_METHOD.OPTIONS.Foil': 'Feuille',

    'TAG_WIZARD.PRINTING_METHOD.FOIL_ALERT':
        "L'aperçu du marquage en feuille n'est qu'un exemple et les polices seront ajustées à la taille maximale disponible si possible. Les lettres de marque Lazy ne sont pas affichées mais seront estampillées en fonction des détails de votre commande. Les commandes de papier d’aluminium seront traitées manuellement une fois soumises.",

    'TAG_WIZARD.PROPERTY.HEADING': 'Détails de la propriété',
    'TAG_WIZARD.PROPERTY.DESCRIPTION':
        "Saisissez les détails de votre code PIC NLIS (Système national d'identification du bétail) ci-dessous afin que nous puissions valider que votre PIC, le nom de la propriété et le nom du propriétaire correspondent à la base de données NLIS. Les détails doivent être saisis exactement de la même manière que ce qui est enregistré au code PIC dans votre état.",
    'TAG_WIZARD.PROPERTY.VALIDATE_BUTTON_TEXT': 'Valider les détails',
    'TAG_WIZARD.PROPERTY.FAILED_VALIDATION':
        'Le code PIC que vous avez saisi est incorrect. Veuillez vérifier vos informations et cliquer sur réessayer.',
    'TAG_WIZARD.PROPERTY.FAILED_VALIDATION_PROCEED':
        'Les détails du code PIC que vous avez saisis ont été validés, mais les données associées ne correspondent pas aux informations enregistrées dans la base de données NLIS. S’il vous plaît vérifier vos informations et cliquez sur réessayer ou procéder sans validation.',
    'TAG_WIZARD.PROPERTY.SUCCESSFUL_VALIDATION':
        'Détails validés avec succès',
    'TAG_WIZARD.PROPERTY.INACTIVE_VALIDATION':
        "Votre code PIC est indiqué comme étant supprimé, inactif ou bloqué. Pour plus de détails, veuillez contacter l'organisme gouvernemental de votre état.",
    'TAG_WIZARD.PROPERTY.INACTIVE_VALIDATION_AU_ALTERNATIVE_BUTTON':
        'Voir liens utiles - Australie',

    'TAG_WIZARD.PROPERTY.NLIS.PIC_VIC_VALIDATION_WARNING':
        'Toutes les commandes électroniques d’étiquettes NLIS pour VIC doivent être traitées par l’intermédiaire du VIC DPI.',
    'TAG_WIZARD.PROPERTY.NLIS.PIC_DPI_WARNING': 'Visitez VIC DPI',
    'TAG_WIZARD.PROPERTY.NLIS.PIC_DPI_PROCEED': 'Procéder sans validation',

    'TAG_WIZARD.PROPERTY.NLIS.STARTING_NUMBER.DESCRIPTION':
        'Le numéro indiqué dans ce champ est le premier numéro disponible (p. ex., 00001) ou votre prochain numéro disponible au cours de la même année. Les numéros d’identification NLIS ne peuvent pas être dupliqués au cours de la même année.',
    'TAG_WIZARD.PROPERTY.NLIS.PREFIX.DESCRIPTION':
        'Une chaîne alphanumérique qui apparaît avant votre numéro de départ',

    'TAG_WIZARD.PROPERTY.NLIS.CHECKBOX.DESCRIPTION':
        'En cochant cette case, vous autorisez Leader Products à obtenir un numéro d’autorisation DAF en votre nom (Veuillez noter que cela pourrait retarder le délai de traitement de votre commande).',

    'TAG_WIZARD.PROPERTY.NLIS.BRAND.DESCRIPTION':
        'Saisissez votre marque à 3 chiffres pour remplacer le PIC.',

    'TAG_WIZARD.PROPERTY.NLIS.LAZY_LETTER.DESCRIPTION':
        'Pour demander une lazy letter, utilisez les codes suivants : 0 = pas de lazy letter, 1 = lazy letter première position, 2 = lazy letter deuxième position, 3 = une flèche sera utilisée dans la position centrale. Veuillez noter que : Les lazy letters ne seront pas affichées dans l’aperçu de l’étiquette à l’étape suivante.',

    'TAG_WIZARD.APPEARANCE.TAG_APPEARANCE.HEADING': 'Apparence de l’étiquette',
    'TAG_WIZARD.APPEARANCE.LAYOUT_VARIATIONS.HEADING': 'Variations de mise en page',
    'TAG_WIZARD.APPEARANCE.MARKING_SIDES.HEADING': 'Marquage des côtés',
    'TAG_WIZARD.APPEARANCE.MARKING_SIDES.HEADING_TOOLTIP':
        'Côtés de marquage disponibles indiqués ci-dessous',
    'TAG_WIZARD.APPEARANCE.TAG_DESIRED_LAYOUT_MESSAGE': 'Sélectionnez la variation de mise en page souhaitée parmi les options ci-dessous',
    'TAG_WIZARD.APPEARANCE.SELECT_VARIATION': 'Sélectionnez la variation',
    'TAG_WIZARD.APPEARANCE.CUSTOM_LAYERS': 'Couches personnalisées',
    'TAG_WIZARD.APPEARANCE.ITEM_INCLUDED': 'Article inclus',
    'TAG_WIZARD.REVIEW.TEST_BUTTON_TEXT': 'DONNÉES DE TEST : Exporter les données JSON',

    'TAG_WIZARD.PRINTABLE_SIDE.FRONT.ACTIVE_LABEL': 'Recto',
    'TAG_WIZARD.PRINTABLE_SIDE.FRONT.ACTIVE_SUBLABEL': '(Inclus)',
    'TAG_WIZARD.PRINTABLE_SIDE.FRONT.INACTIVE_LABEL': 'Impression recto',
    'TAG_WIZARD.PRINTABLE_SIDE.BACK.ACTIVE_LABEL': 'Verso',
    'TAG_WIZARD.PRINTABLE_SIDE.BACK.ACTIVE_SUBLABEL': '(Facultatif)',
    'TAG_WIZARD.PRINTABLE_SIDE.BACK.INACTIVE_LABEL': 'Imprimer verso',

    'TAG_WIZARD.REVIEW.HEADING': "Révision de l'étiquette",
    'TAG_WIZARD.REVIEW.DESCRIPTION':
        'Veuillez vérifier la conception de votre étiquette et la quantité commandée avant de l’ajouter à votre panier.',

    'TAG_WIZARD.PRICE_SUMMARY.HEADING': 'Résumé des prix',
    'TAG_WIZARD.PRICE_SUMMARY.TOTAL_PRICE': 'Prix total',

    'TAG_WIZARD.TAG_REVIEW.PIC_NOT_VERIFIED':
        'LE NOM DE LA PROPRIÉTÉ/DU PROPRIÉTAIRE NÉCESSITE UNE VÉRIFICATION MANUELLE',
    'TAG_WIZARD.TAG_REVIEW.PIC_NUMBER': 'Numéro PIC',
    'TAG_WIZARD.TAG_REVIEW.FIRST_NAME': 'Prénom',
    'TAG_WIZARD.TAG_REVIEW.LAST_NAME': 'Nom de famille',
    'TAG_WIZARD.TAG_REVIEW.BUSINESS_NAME': 'Nom d’entreprise',
    'TAG_WIZARD.TAG_REVIEW.PROPERTY_NAME': 'Nom de la propriété',
    'TAG_WIZARD.TAG_REVIEW.OWNER_NAME': 'Nom du propriétaire',
    'TAG_WIZARD.TAG_REVIEW.INCLUDED_ITEM': 'Article inclus',
    'TAG_WIZARD.TAG_REVIEW.MARKING_METHOD': 'Méthode de marquage',
    'TAG_WIZARD.TAG_REVIEW.LAYOUT_VARIATION': 'Variation de mise en page',
    'TAG_WIZARD.TAG_REVIEW.CUSTOM_FIELD': 'Champ personnalisé',

    'TAG_WIZARD.TAG_REVIEW.BREEDER_POST_CODE': 'Code d’éleveur/post-éleveur',
    'TAG_WIZARD.TAG_REVIEW.YEAR_CODE': 'Code de l’année',
    'TAG_WIZARD.TAG_REVIEW.STARTING_NUMBER': 'Numéro de départ',
    'TAG_WIZARD.TAG_REVIEW.SEQUENCE_NUMBERS': 'Numéros de séquence',
    'TAG_WIZARD.TAG_REVIEW.PREFIX': 'Préfixe',
    'TAG_WIZARD.TAG_REVIEW.DISEASE_CODE': 'Code des maladies',
    'TAG_WIZARD.TAG_REVIEW.LOGO': 'LOGO',
    'TAG_WIZARD.TAG_REVIEW.STATE': 'État',
    'TAG_WIZARD.TAG_REVIEW.DAF_AUTHORISATION_ISSUE_DATE':
        'Date d’émission d’autorisation du DAF',
    'TAG_WIZARD.TAG_REVIEW.DAF_AUTHORISATION_NUMBER':
        'Numéro d’autorisation DAF',
    'TAG_WIZARD.TAG_REVIEW.DAF_AUTHORISATION': 'Autorisation DAF',
    'TAG_WIZARD.TAG_REVIEW.USE_BRAND_OVER_PIC': 'Marque non PIC',
    'TAG_WIZARD.TAG_REVIEW.LAZY_LETTER': 'Lazy Letter',

    'TAG_WIZARD.TAG_REVIEW_MMT.MARKING_TYPE': 'Type de marquage',
    'TAG_WIZARD.TAG_REVIEW_MMT.PIC_NUMBER': 'Numéro PIC',
    'TAG_WIZARD.TAG_REVIEW_MMT.PROPERTY_NAME': 'Nom de la propriété',
    'TAG_WIZARD.TAG_REVIEW_MMT.SEQUENCE_NUMBERS': 'Numéros de séquence',
    'TAG_WIZARD.TAG_REVIEW_MMT.PREFIX': 'Préfixe',

    'TAG_WIZARD.SIDEMENU.MARKING_OPTIONS.STYLE_OPTIONS': 'Options de style',
    'TAG_WIZARD.SIDEMENU.MARKING_OPTIONS.TEXT_ALIGNMENT': 'Alignement du texte',
    'TAG_WIZARD.SIDEMENU.MARKING_OPTIONS.OBJECT_POSITION': 'Position de l’objet',
    'TAG_WIZARD.SIDEMENU.MARKING_OPTIONS.ROTATE': 'Tourner',
    'TAG_WIZARD.SIDEMENU.MARKING_OPTIONS.FLIP': 'Retourner',
    'TAG_WIZARD.SIDEMENU.MARKING_OPTIONS.ORIENTATION': 'Orientation',

    'TAG_WIZARD.LAYERS.CUSTOMER_MARKING': 'AJOUTER LE MARQUAGE PERSONNALISÉ',
    'TAG_WIZARD.LAYERS.LINE_TEXT': 'LIGNE',
    'TAG_WIZARD.LAYERS.EDITABLELAYERS': 'Couches modifiables',
    'TAG_WIZARD.DROPZONE.DRAGTEXT': 'Faites glisser le fichier ici ou cliquez pour télécharger',
    'TAG_WIZARD.DROPZONE.SVGTEXT': 'Veuillez noter que seuls les fichiers d’extension SVG seront acceptés. Taille max : 3 Mo.',
    'TAG_WIZARD.MARKING.OPTIONS': 'Options de marquage',
    'TAG_WIZARD.APPEARANCE.CUSTOM_TEXT': "Saisissez votre texte personnalisé ci-dessous. Le texte apparaît sur l'image du produit au fur et à mesure que vous tapez, et peut être redimensionné et déplacé en cliquant sur l'objet ou en cliquant et en faisant glisser les poignées. La police, l’alignement et le style peuvent également être modifiés ci-dessous.",

    'TAG_WIZARD.MARKING.TEXT.DESCRIPTION.DEFAULT':
        "Saisissez votre texte personnalisé ci-dessous. Le texte peut être redimensionné et déplacé autour de l'étiquette en cliquant et en faisant glisser les poignées. Le style de police, la taille, l’espacement et l’alignement peuvent également être modifiés en utilisant les options ci-dessous.",
    'TAG_WIZARD.MARKING.SEQUENCE.DESCRIPTION.DEFAULT':
        'Saisissez votre numéro de départ ci-dessous. Pour ajouter un préfixe, un suffixe ou modifier les incréments sélectionnez les options avancées ci-dessous. Votre quantité déterminera le dernier numéro.',
    'TAG_WIZARD.MARKING.LIST.DESCRIPTION.DEFAULT':
        'Tapez ou coller une liste personnalisée dans le champ ci-dessous. Chaque ligne sera imprimée sur une étiquette séparée. Le style de police, la taille, l’espacement et l’alignement peuvent également être modifiés ci-dessous en fonction de vos besoins. Lorsque vous saisissez plusieurs lignes, la quantité de lignes doit correspondre à la quantité d’étiquettes que vous avez commandées.',
    'TAG_WIZARD.MARKING.IMAGE.DESCRIPTION.DEFAULT':
        'Téléchargez un logo ou une image personnalisée en faisant glisser votre fichier directement sur la case ci-dessous, ou en cliquant et en recherchant votre fichier. Le format de fichier doit être un fichier SVG noir et blanc pour correspondre à nos exigences d’impression laser. Vous pouvez également essayer <a href="https://convertio.co/jpg-svg/">www.convertio.co</a> pour convertir votre logo actuel dans le format SVG correct.',
    'TAG_WIZARD.MARKING.CODE.DESCRIPTION.DEFAULT':
        'Sélectionnez votre type de code, tel que le code à barres ou le code QR dans le premier champ. Saisissez ensuite le contenu de votre code et voyez l’aperçu apparaître sur l’image du produit. Vous pouvez également activer le mode séquence en cochant la case et en suivant les invites.',
    'TAG_WIZARD.MARKING.RFID.DESCRIPTION.DEFAULT':
        'Veuillez noter que l’image affichée est une représentation de la façon dont votre étiquette apparaîtra lorsqu’elle sera marquée. Le numéro RFID réel ne peut pas être déterminé tant que la production n’a pas commencé. Pendant la production, les étiquettes sont numérisées par un lecteur RFID et le numéro RFID enregistré. Le numéro RFID enregistré est ensuite apparié et marqué au laser sur l’étiquette.',
    'TAG_WIZARD.MARKING.RFID.OPTIONS.DEFAULT': 'Sélectionnez l’une des options de marquage ci-dessus pour commencer.',

    // Cartes de crédit
    CARD_NAME: 'Nom de la carte',
    CARD_NUMBER: 'Numéro de carte',
    ADD_CREDIT_CARD: 'Ajouter la carte',
    ADD_NEW_CREDIT_CARD: 'Ajouter une nouvelle carte',

    // Commandes clients
    'CUSTOMER_ORDERS.RECENT_CUSTOMER_ORDERS.HEADING': 'Commandes clients récentes',
    'CUSTOMER_ORDERS.AWAITING_APPROVAL.HEADING': 'En attente d’approbation',
    'CUSTOMER_ORDERS.AWAITING_RESELLER_APPROVAL.HEADING':
        'En attente de l’approbation du revendeur',
    'CUSTOMER_ORDERS.APPROVED.HEADING': 'Approuvé',
    'CUSTOMER_ORDERS.BACK-ORDERED.HEADING': 'Back Orders',
    'CUSTOMER_ORDERS.REJECTED.HEADING': 'Rejeté',
    'CUSTOMER_ORDERS.CUSTOMER_CONTACTED.HEADING': 'Contacter le client',
    'CUSTOMER_ORDERS.ON_ACCOUNT.HEADING': 'En attente de paiement',
    'CUSTOMER_ORDERS.ON_ACCOUNT_PAYMENT_RECEIVED.HEADING': 'Paiement reçu',
    'CUSTOMER_ORDERS.ON_ACCOUNT_PAYMENT_SENT.HEADING': 'Paiement envoyé',

    APPROVAL_STATUS: 'Statut d’approbation',

    // Paiement
    SELECT_ADDRESS: "Sélectionnez l'adresse",
    SELECT_BILLING_ADDRESS: 'Sélectionnez l’adresse de facturation',
    SELECT_DELIVERY_ADDRESS: 'Sélectionnez l’adresse de livraison',
    SELECT_DELIVERY_OPTION: "Sélectionnez l'option de livraison",

    // Tableau de réaction Supprimer une rangée
    REMOVE_ITEM_FROM_LIST: 'Supprimer l’élément de la liste ?',

    // Pagination
    NEXT: 'Suivant',
    PREV: 'Précédent',

    // Commun
    ALL: 'Tous',
    DISPATCH_STATUS: "Statut de l'expédition",
    DELIVER_TO: 'Livrer à',
    NO_OF_ARTICLES: 'N° ARTICLES',
    ADVANCED_OPTIONS: 'Options avancées',
    APPROVE: 'Approuver',
    APPROVED: 'Approuvé',
    REJECTED: 'Rejeté',
    BUYER_CONTACTED: 'Acheteur contacté',
    APPROVAL: 'Statut d’approbation',
    CONTACT_CUSTOMER: 'Contacter le client',
    COST: 'Coût',
    CLOSE: 'Proche',
    DEFAULT: 'Par défaut',
    STATUS: 'Statut',
    DATE: 'Date',
    ACTIVE_FILTERS: 'Filtres actifs',
    CLEAR_ALL_FILTERS: 'Effacer tous les filtres',
    REFINE_RESULTS: 'Affiner les résultats',
    'REFINE_RESULTS.MOBILE': 'Affiner',
    'REFINE_RESULTS.DESKTOP': 'Affiner les résultats',
    REFINE: 'Affiner',
    RESULTS: 'résultats',
    AMOUNT: 'Montant',
    APPLY_FILTERS: 'Appliquer des filtres',
    FILTER: 'Filtre',
    DESCRIPTION: 'Description',
    CATEGORY: 'Catégorie',
    ADD_CATEGORY: 'Ajouter la catégorie',
    SELECT_CATEGORY: 'Sélectionner la catégorie',
    CREATE: 'Créer',
    CANCEL: 'Annuler',
    CONFIRM: 'Confirmer',
    CODE: 'Code',
    TYPE: 'Type',
    PRINT: 'Imprimer',
    FROM: 'De',
    BUY_NOW: 'Acheter maintenant',
    ON_SALE: 'En vente',
    ADDRESS: 'Adresse',
    BILLING_ADDRESS: 'Adresse de facturation',
    SHIPPING_ADDRESS: 'Adresse d’expédition',
    PRICE: 'Prix',
    UNIT_PRICE: 'Prix unitaire',
    EDIT: 'Modifier',
    REMOVE: 'Retirer',
    DELETE: 'Supprimer',
    SAVE: 'Sauvegarder',
    SAVE_BANK_DETAILS: 'Enregistrer les coordonnées bancaires',
    SAVE_AND_CONTINUE: 'Enregistrer et continuer',
    SAVE_AND_CONTINUE_TO_STRIPE: 'Enregistrer et continuer vers Stripe',
    VIEW: 'Vue',
    VIEW_DETAILS: 'Voir les détails',
    'RESULT(S)': 'Résultat(s)',
    PRINT_PACKING_LABEL: "Imprimer l'étiquette de l'emballage",
    NEXT_STEP: 'Prochaine étape',
    RETRY: 'Réessayer',
    OR: 'Ou',
    COUPON_COPY_CODE: 'Code de copie',
    PRODUCT_LIST_ITEM_LINK_TITLE_ID: 'Cliquez pour voir toutes les couleurs disponibles',
    ENTER_ADDRESS_MANUALLY: 'Saisir l’adresse manuellement',
    SOLD_BY: 'Vendu par',
    ORDERED_BY: 'Commandé par',
    CONTAIN_TAGS: 'Contenir des étiquettes',
    CONTAINS: 'Contient',
    CARRIER: 'Transporteur',
    EDIT_BANK_DETAILS: 'Modifier les coordonnées bancaires',
    EDIT_STRIPE_CONFIGURATION: 'Modifier la configuration Stripe',
    VIEW_EDIT_DETAILS: 'Afficher / modifier les détails',
    DOWNLOAD: 'Télécharger',
    N_A: 'Néant',
    MINIMUM_ORDER_QTY: 'Quantité minimale de commande',
    REF: 'RÉF',
    APPLY_CHANGES: 'Appliquer les modifications',
    FILTERS: 'Filtres',
    DISPLAY: 'Affichage',
    PRODUCTS: 'Produits',

    // RAPPORTS
    REPORTS_HEADING: 'Sélectionnez un rapport',
    REPORTS_GENERATE_REPORT: 'GÉNÉRER UN RAPPORT',
    REPORTS_EXPORT_CSV: 'Exporter au format CSV',
    EXPORT: 'exporter',

    // TABLEAU
    TABLE_NO_ITEMS_FOUND: 'Aucun article trouvé',
};

export default resources;
